import { Link } from "@tanstack/react-router";
import ITag from '../../../components/ITag'

/**
 * CardIco component.
 *
 * Simple card with a "Load More" button linking to home page.
 * Likely a placeholder for additional content/feature showcase.
 *
 * @module containers/Explore2/CardIco
 * @returns {React.ReactElement} Card with load more button
 */
const CardIco = () => {

  return (
      <div className="col-12 py-4">
        <div className="card">
          
          <div className="card-body">
            <div className="row">
              <div className="col-md-12 text-center">
                <Link className="btn bg-gradient-dark mb-0" to="/"><ITag ClassName="fas fa-plus mr-10" />Load More</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default CardIco;